import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/modules/common/views/home/index.vue'),
        meta: {
          title: '首页',
          auth: true,
          isKeepAlive: true,
        },
      },
    ],
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('./views/error-page/404.vue'),
    meta: {
    },
  },

  {
    path: '/403',
    name: 'NoAuth',
    component: () => import('./views/error-page/403.vue'),
    meta: {},
  },

  {
    path: '/401',
    name: 'NoLogin',
    component: () => import('./views/error-page/401.vue'),
    meta: {},
  },
  {
    path: '/redirect',
    component: () => import('@/layouts/main/index.vue'),
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('./views/redirect/index.vue'),
        meta: {},
      },
    ],
  },
] as IRouteConfig[];
